/**
 * Human-readable labels for Kinnser / intake validation field names.
 *
 * Used when rendering validation bullets so we never surface raw snake_case
 * names to end users. Unknown fields fall back to a simple humanized name.
 */

const FIELD_LABELS: Record<string, string> = {
  agency_clinic_id: 'Clinic',
  kinnser_clinic_id: 'Clinic',
  kinnser_branch_id: 'Branch',
  kinnser_physician_id: 'Physician',
  kinnser_insurance_provider_id: 'Insurance Provider',
  kinnser_admission_type: 'Admission Type',
  kinnser_hcpcs_code_key: 'HCPCS Code',
  kinnser_mrn: 'MRN',
  kinnser_language_key: 'Language',
  kinnser_other_language: 'Other Language',
  patient_primary_language: 'Primary Language',
  f2f_encounter_date: 'Face-to-Face Encounter Date',
  patient_first_name: 'First Name',
  patient_middle_name: 'Middle Name',
  patient_last_name: 'Last Name',
  patient_suffix: 'Suffix',
  patient_dob: 'Date of Birth',
  patient_gender: 'Gender',
  patient_ssn: 'SSN',
  patient_phone: 'Phone',
  patient_secondary_phone: 'Secondary Phone',
  patient_email: 'Email',
  patient_street_address: 'Street Address',
  patient_city: 'City',
  patient_state: 'State',
  patient_zip_code: 'Zip Code',
  patient_county: 'County',
  emergency_contact_name: 'Emergency Contact Name',
  emergency_contact_phone: 'Emergency Contact Phone',
  emergency_contact_zip_code: 'Emergency Contact Zip',
  kinnser_visit_type: 'Visit Type',
  kinnser_creation_type: 'Creation Type',
  kinnser_type_of_soc: 'Type of SOC',
  kinnser_soc_date: 'SOC Date',
  kinnser_episode_start_date: 'Episode Start Date',
  kinnser_clinician_id: 'Clinician',
  kinnser_clinical_care_manager_id: 'Clinical Care Manager',
  kinnser_case_manager_id: 'Case Manager',
  kinnser_oasis_approver_id: 'OASIS Approver',
  kinnser_pt_approver_id: 'PT Approver',
  kinnser_ot_approver_id: 'OT Approver',
  kinnser_st_approver_id: 'ST Approver',
  kinnser_primary_scheduler_id: 'Primary Scheduler',
  kinnser_secondary_scheduler_id: 'Secondary Scheduler',
  roc_date: 'ROC Date',
  roger_type_of_soc: 'Type of SOC',
  soc_date: 'SOC Date',
  episode_start_date: 'Episode Start Date',
  roger_clinician_id: 'Clinician',
  roger_case_manager_id: 'Case Manager',
};

/**
 * Produce a display label for a backend field name.
 */
export function getFieldLabel(field: string): string {
  const label = FIELD_LABELS[field];
  if (label) return label;
  return field
    .split('_')
    .map(part => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
}
